import { AppConfig } from '@m4u-angular/configuration/app.config.model';
import { Observable, of } from 'rxjs';
import { DefaultRouteParams } from '@m4u-angular/base/classes/BaseClasses';
import { BaseDataSourceAbstract } from '@m4u-angular/base/datalayer/BaseDataSourceAbstract';
import { RegistrationComponent } from './pages/registration/registration.component';
import { CreditCardComponent } from './pages/credit-card/credit-card.component';
import { CityEndpoint } from '@telrun-client/_proxy/endpoints/city.endpoint';
import { CityPackageEndpoint } from '@telrun-client/_proxy/endpoints/citypackage.endpoint';
import { RegistrationEndpoint } from './_proxy/endpoints/registration.endpoint';
import { Lists_EN } from './_resources/LISTS_EN';
import { Lists_HE } from './_resources/LISTS_HE';

class TelrunAppConfig extends AppConfig {
    override ModuleName = "Telrun";

    override Components = [
        RegistrationComponent,
        CreditCardComponent
    ];
    override Endpoints = [
        CityEndpoint,
        CityPackageEndpoint,
        RegistrationEndpoint
    ];
    override Services = [];
    override RoutesWithEmptyLayout = [
        { path: 'registration', component: RegistrationComponent  },
        { path: 'credit-card', component: CreditCardComponent },
    ];

    override OnGetMenu = () => of([

    ]);
    override OnGetDefaultRouteParams = (userInfo?: any) => {
        const defaultRouteParams = new DefaultRouteParams();
        defaultRouteParams.Route = '/pages/registration';
        return of(defaultRouteParams);
    };
    override OnGetGlobalDataSources = (): Observable<{ [id: string]: BaseDataSourceAbstract }> => {
        //Static datasources 
        const staticDataSources = {};

        (Object as any).values(staticDataSources).forEach(x => x.Data.load());

        //Live datasources
        const liveDataSources = {};

        return of({ ...staticDataSources, ...liveDataSources });
    };
    override OnInitApplicationAsync = (): Observable<boolean> => {
        return of(true);
    }

    override GetLists = () => [Lists_EN, Lists_HE];

    override Enums = {};
}

export const appConfig: AppConfig = new TelrunAppConfig();